import PaymentItem from "./PaymentItem";
import Event from "./Event";
import PaymentNotification from "./PaymentNotification";
import PaymentGateway from "./PaymentGateway";

export enum OrderStatus {
  ALL = "",
  CONFIRMED = "Confirmado",
  PENDING_PAYMENT = "Aguardando Pagamento",
  CANCELLED = "Cancelado",
  DENIED = "Recusado",
  COURTESY = "Cortesia",
}

export default interface Order {
  id: string;
  quantidade: 1;
  evento_id: string;
  tipo: string;
  desconto: string;
  valor: string;
  setor_id: string;
  setor_nome: string;
  secao_id: string;
  carga_id: string;
  secao_nome: string;
  cadeira: null;
  taxa_conveniencia: string;
  cpf: string;
  portador: string;
  codigo_barras: string;
  created_at: "2019-04-23T11:48:31.000000Z";
  updated_at: "2019-04-23T15:14:43.000000Z";
  order_number: string;
  usuario_id: string;
  reserva_id: string;
  situacao: OrderStatus;
  valor_total: string;
  /** The card interest the buyer paid above the Order's total, in reais. Absent before the API's migration. */
  buyer_interest?: string;
  itens_total: number;
  evento_nome: string;
  event: Event;
  items: PaymentItem[];
  notification: PaymentNotification;
  cielo_array: string;
  payment_method_id: number;
  gateway: PaymentGateway;
}
